import moment from "moment";

const DATE_FORMAT: string = "YYYY-MM-DD";
const DATE_FORMAT1: string = "T00:00:00.000";
// This need to be defined when there is a need for local time zone
// const DATE_FORMAT2: string = "T00:00:00.000Z";

Date.prototype.toUtcFormat = function(): string {
    return moment(this).format(DATE_FORMAT + DATE_FORMAT1);
};